import { ListComponent } from "./List";

const components = {
  list: ListComponent
}

export default components;